var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoneWall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 0h10M0 1h1m10 0h1M0 2h1m10 0h1M0 3h1m10 0h1M0 4h1m10 0h1M0 5h1m10 0h1M0 6h1m10 0h1M0 7h1m10 0h1M0 8h1m10 0h1M0 9h1m10 0h1M0 10h1m10 0h1M1 11h10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#82794f",
    d: "M1 1h5m1 0h4M1 2h1M1 3h1M1 4h1m1 0h1M1 6h1M1 7h1M1 8h1m5 0h1M1 9h1m-1 1h1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#404040",
    d: "M6 1h1M2 2h8M2 3h8M2 4h1m1 0h4m1 0h1M1 5h9M2 6h8M2 7h1m1 0h6M2 8h5m1 0h3M2 9h8m-5 1h1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#212133",
    d: "M10 2h1m-1 1h1M8 4h1m1 0h1m-1 1h1m-1 1h1M3 7h1m6 0h1m-1 2h1m-9 1h3m1 0h5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoneWall);
export default __webpack_public_path__ + "static/media/stone-wall.893668abe7beb7cf92614cf4d57b4e7a.svg";
export { ForwardRef as ReactComponent };